var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-login" },
    [
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: {
            model: _vm.loginForm,
            rules: _vm.loginRules,
            "label-position": "left",
            "label-width": "24px",
            "content-width": "350px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              ref: "emailFormItem",
              attrs: { prop: "email" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_c("i", { staticClass: "icomoon-common_user" })]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("el-input", {
                attrs: {
                  tips: _vm.$t("v_email"),
                  placeholder: _vm.$t("e-mail"),
                  maxlength: 128,
                },
                on: { change: _vm.emailChange },
                nativeOn: {
                  keypress: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onLogin.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.loginForm.email,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.loginForm,
                      "email",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "loginForm.email",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              ref: "passwordFormItem",
              attrs: { prop: "password" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_c("i", { staticClass: "icomoon-common_lock" })]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "div",
                [
                  _c("cloud-password", {
                    attrs: {
                      placeholder: _vm.$t("password"),
                      maxlength: 32,
                      "force-show-eyes": "",
                    },
                    nativeOn: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onLogin.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.loginForm.password,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.loginForm,
                          "password",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "loginForm.password",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm.needVerifyCode
            ? _c(
                "el-form-item",
                {
                  ref: "verifyCodeFormItem",
                  attrs: { prop: "verifyCode" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "icomoon-common_lock" }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4131992531
                  ),
                },
                [
                  _c("el-input", {
                    directives: [
                      { name: "input-limit", rawName: "v-input-limit" },
                    ],
                    staticClass: "login-code-input",
                    attrs: {
                      placeholder: _vm.$t("enter_img_verify_code"),
                      "data-input-type": "alphanumeric",
                      maxlength: 4,
                    },
                    nativeOn: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onLogin.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.loginForm.verifyCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.loginForm,
                          "verifyCode",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "loginForm.verifyCode",
                    },
                  }),
                  _c("img", {
                    staticClass: "login-code-pic",
                    attrs: {
                      src: _vm.verifyImg,
                      alt: "",
                      crossorigin: "anonymous",
                    },
                    on: { click: _vm.changeCode },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "auto-content" },
        [
          _c(
            "el-checkbox",
            {
              staticStyle: { "vertical-align": "middle" },
              model: {
                value: _vm.rememberLogin,
                callback: function ($$v) {
                  _vm.rememberLogin = $$v
                },
                expression: "rememberLogin",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("HPP-web_remember_login_msg", { 0: "7" })) +
                  "\n    "
              ),
            ]
          ),
          _vm.rememberLogin
            ? _c("div", [
                _vm._v(_vm._s(_vm.$t("HPP-web_remember_login_warn_msg"))),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "password-button",
          attrs: { type: "link", title: _vm.$t("forgot_password") },
          on: {
            click: function ($event) {
              return _vm.toReset()
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("forgot_password")) + "\n  ")]
      ),
      _c(
        "div",
        { staticClass: "entry-button-warp" },
        [
          _c(
            "el-button",
            {
              staticClass: "entry-button",
              attrs: { title: _vm.$t("login"), type: "primary" },
              on: { click: _vm.onLogin },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("login")) + "\n    ")]
          ),
          _vm.showOneHik
            ? _c(
                "t",
                {
                  staticClass: "to-onehiklogin",
                  attrs: { lang: "upgraded_please_use", tag: "span" },
                },
                [
                  _c("button", {
                    staticClass: "el-button el-button--link",
                    on: { click: _vm.toOneHikIdLogin },
                  }),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "cloud-dialog",
        {
          staticClass: "login-resend-dialog",
          model: {
            value: _vm.resendModel,
            callback: function ($$v) {
              _vm.resendModel = $$v
            },
            expression: "resendModel",
          },
        },
        [
          _c("div", { staticClass: "dialog-info-position" }, [
            _c("i", { staticClass: "icon-img_information" }),
          ]),
          _c("div", { staticClass: "dialog-content" }, [
            _c("div", { staticClass: "dialog-title" }, [
              _vm._v(_vm._s(_vm.$t("confirm"))),
            ]),
            _c("div", { staticClass: "dialog-text" }, [
              _c("p", { staticClass: "dialog-tip" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("LAP001015").replace("{0}", _vm.loginForm.email)
                  )
                ),
              ]),
              _c(
                "div",
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("never_receive_email")))]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "link" },
                      on: { click: _vm.handleResend },
                    },
                    [_vm._v(_vm._s(_vm.$t("resend")))]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "el-button",
            {
              staticClass: "close-button",
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.resendModel = false
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("haven_active")) + "\n    ")]
          ),
        ],
        1
      ),
      _c("authentication-entry-dialog", {
        attrs: {
          "login-form": { loginForm: _vm.loginForm },
          visible: _vm.showAuthentication,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showAuthentication = $event
          },
          confirm: function ($event) {
            _vm.handleAuthenticationFn.resolve &&
              _vm.handleAuthenticationFn.resolve()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }